import React, { useEffect, useState } from 'react';
import { Global } from '@emotion/react';
import { useLocation } from 'react-router-dom';

import { globalStyles } from '~/styles/global';
import PageHeader from '~/components/layout/header/PageHeader';
import Routes from '~/routes';

import { Modal } from '~/components/common';
import PageRootContainer from '~/components/layout/PageRootContainer';
import PageFooter from '~/components/layout/PageFooter';

import config from '~/config';
import { useDispatch } from './redux';
import { actions } from '~/redux/reducers';
import queryString from 'query-string';
import ReactGA from 'react-ga';

function App() {
  // redux state
  const dispatch = useDispatch();

  // // local state
  const [ready, setReady] = useState(false);

  // router - query params
  const location = useLocation();
  const query = queryString.parse(location.search);

  useEffect(() => {
    if (config.debug) { console.log('load query params on app entry', query)};

    dispatch({
      type: actions.UPDATE_ENTRY_PARAMS,
      payload: query
    });

    setReady(true);
  }, [dispatch, query]);

  // on app load
  useEffect(() => {
    // initialize Google Analyitcs
    ReactGA.initialize(config.gaTrackingId, {
      debug: config.debug
    })
  }, []);

  // on route change
  useEffect(() => {
    // always scroll to top
    (document.scrollingElement || document.documentElement)?.scrollTo(0, 0);

    // Google Analytics -- record page event
    ReactGA.pageview(window.location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Global styles={globalStyles} />
      <PageRootContainer>
        <PageHeader />
        <main>
          { !!ready && <Routes />}
        </main>
        <PageFooter />
      </PageRootContainer>
      <Modal />
    </>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx